import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom'
import { Header, Sidebar } from "../Layout";
// import Error from '../shared/Error'
import Multiselect from 'multiselect-react-dropdown';
import { useDispatch, useSelector } from "react-redux";
import { generateJobNumber } from '../../utility/helper'
import 'react-taggables-input/dist/tags.css';
import DatePicker from "react-datepicker";
import { useFormik } from 'formik';
import * as Yup from "yup";
import * as actionTypes from '../../constants/userActionTypes'
import { createProjectDetail, getCampaignList, checkUserEmail, checkJobNumberUnique } from '../../actions/projectActions'
import { getMembers } from "../../actions/memberActions";
import moment from 'moment';
// import { toast } from 'react-toastify';
import { MEMBER } from '../../constants/constants';
import AddMemberModal from '../Members/AddMemberModal'
import { VALIDATE_EMAIL, VALIDATE_JOB_NUMBER } from '../../constants/constants'

const CreateProject = () => {

  const { members } = useSelector(state => state.memberStore);
  const { campaigns, loading, projectLimit, userEmails } = useSelector(state => state.projectStore);
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const [endDate, setEndDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [searchEmail, setSearchEmail] = useState([]);
  const [currentPartnerEmail, setCurrentPartnerEmail] = useState();
  const [selectedPartners, setSelectedPartners] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedReferences, setSelectedReferences] = useState([]);
  const [showAddAdminModal, setAddAdminModal] = useState(false);
  const [selectedRowData, setselectedRowData] = useState(false);

  useEffect(() => {
    if (user.userType === MEMBER) history.push('/')
    dispatch(getCampaignList())
    dispatch(getMembers())
    const jobNumber = generateJobNumber()
    formik.setFieldValue('job_number', jobNumber)
  }, [dispatch, history, user])

  useEffect(() => {
    if (userEmails) {
      dispatch({ type: actionTypes.CHECK_USER_BY_EMAIL_RESET })
    }
    if (userEmails) setSearchEmail(userEmails);

  }, [userEmails, dispatch])

  const formik = useFormik({
    initialValues: {
      title: '',
      job_number: '',
      partner: '',
      // campaign_name: '',
      project_start_date: moment(new Date()).format('YYYY-MM-DD'),
      project_end_date: moment(new Date()).format('YYYY-MM-DD'),
      // isCampaign: '',
      // campaign_id: '',
      campaigns: [],
      partner_emails: '',
      member_emails: '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      title: Yup.string().required('Brief title is requied'),
      job_number: Yup.string().required('Job number is requied').matches(VALIDATE_JOB_NUMBER, "Job number is invalid")
        .test('checkJobNumberUnique', 'This job number is already registered.', value =>
          checkJobNumberUnique(value).then(async res => {
            const response = res.data;
            if (response.is_matched) return false;
            else return true;
          })),
      partner: Yup.string().matches(VALIDATE_EMAIL, "Email is not valid"),
      member_emails: Yup.array().required("Members filed is required").min(1, "Please select at least one member"),
      partner_emails: Yup.array().required('Current partner is requied').min(1, "Please select at least one partner"),
      campaigns: Yup.array(),
      project_start_date: Yup.date().required('Start date is required'),
      project_end_date: Yup.date().min(Yup.ref("project_start_date"), "End date has to be more than start date")
    }),
    onSubmit: (value, { resetForm }) => {
      const formData = {
        title: value.title,
        job_number: value.job_number,
        member_emails: value.member_emails,
        partner_emails: value.partner_emails,
        campaigns: value.campaigns,
        project_start_date: value.project_start_date,
        project_end_date: value.project_end_date,
      }
      // console.log('Form values project', formData)
      dispatch(createProjectDetail(formData, history))
      //resetForm();
    },
  });

  const onSelectStartDate = (date) => {
    formik.setFieldValue('project_start_date', moment(date).format('YYYY-MM-DD'))
    setStartDate(date)
  }

  const onSelectEndDate = (date) => {
    formik.setFieldValue('project_end_date', moment(date).format('YYYY-MM-DD'))
    setEndDate(date)
  }

  const onChangeEmail = (e) => {
    let email = e.target.value;
    let result = email.includes("@");
    if (result) {
      dispatch(checkUserEmail(email))
    } else {
      setSearchEmail([])
    }
    setCurrentPartnerEmail(e.target.value)
    formik.setFieldValue('partner', e.target.value)
  }
  const AddToPartnerEmail = (email) => {
    setCurrentPartnerEmail('')
    let isValid = VALIDATE_EMAIL.test(email);

    if (isValid) {
      const chatHistoryList = [...selectedPartners, { email: email }]; // new array need to update
      const unique = Array.from(new Set(chatHistoryList.map(JSON.stringify))).map(JSON.parse);
      setSelectedPartners(unique); // update the state
      formik.setFieldValue('partner_emails', unique)
      formik.setFieldValue('partner', '')
      setSearchEmail([])
    }

  };
  const onRemoveEmail = (email) => {
    const removeEmail = selectedPartners.filter(item => item !== email)
    setSelectedPartners(removeEmail); // update the state
    formik.setFieldValue('partner_emails', removeEmail)
  }
  const onSelectMembers = (selectedList) => {
    const memberData = selectedList.map(function (item) {
      const value = { id: item.id, email: item.email }
      return value;
    });
    formik.setFieldValue('member_emails', memberData)
    setSelectedMembers(memberData)
  }

  const onRemoveMembers = (selectedList) => {
    // const memberData = selectedList.map(function (item) { return item.email });
    const memberData = selectedList.map(function (item) {
      const value = { id: item.id, email: item.email }
      return value;
    });
    console.log(memberData);
    formik.setFieldValue('member_emails', memberData)
    setSelectedMembers(memberData)
  }

  const onSelectReferences = (selectedList) => {
    formik.setFieldValue('campaigns', selectedList)
    setSelectedReferences(selectedList)
  }

  const onRemoveReferences = (selectedList) => {
    formik.setFieldValue('campaigns', selectedList)
    setSelectedReferences(selectedList)
  }

  const handleAddAdminClose = () => {
    setAddAdminModal(false);
    setselectedRowData(false);
  };
  const handleAddMemberShow = () => {
    setselectedRowData(false);
    setAddAdminModal(true);
  };

  return (
    <>
      <Header />
      <Sidebar />
      <div id="main-content">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h2>Create Project</h2>
            </div>
            <div className="col-md-6 col-sm-12 text-right">
              <ul className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                <li className="breadcrumb-item active">Project / Create</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <form className="form-auth-small" onSubmit={formik.handleSubmit} encType='multipart/form-data'>

            <div className="row clearfix">
              <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                <h3>Project Name</h3>
              </div>
            </div>
            {/* {isProjectLimit ?  <Error error={'Your project limit is end please contact to administrator'}/> : null } */}
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card card-radius">
                  <div className="header card-header custum-bg-warning rounded">
                    <h2 className="text-white">Details</h2>
                  </div>
                  <div className="body card-body-shadow">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label htmlFor="title" className="control-label">Brief Title<span className='text-danger'>*</span></label>
                          <input type="text" name="title" id="title" {...formik.getFieldProps('title')} className="form-control" placeholder='Enter Brief Title' />
                          {formik.touched.title && formik.errors.title ? (
                            <div className="text-danger pt-2">{formik.errors.title}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label htmlFor="job_number" className="control-label">Job Number<span className='text-danger'>*</span></label>
                          <input type="text" id="job_number" placeholder='Enter Job Number' name='job_number'  {...formik.getFieldProps('job_number')} className="form-control" />
                          {formik.touched.job_number && formik.errors.job_number ? (
                            <div className="text-danger pt-2">{formik.errors.job_number}</div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row">

                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label htmlFor="title" className="control-label">Start Date<span className='text-danger'>*</span></label>
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => onSelectStartDate(date)}
                            name="project_end_date"
                            id="project_end_date"
                            className="form-control" />
                          {formik.touched.project_start_date && formik.errors.project_start_date ? (
                            <div className="text-danger pt-2">{formik.errors.project_start_date}</div>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label htmlFor="title" className="control-label">End Date<span className='text-danger'>*</span></label>
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => onSelectEndDate(date)}
                            name="project_end_date"
                            id="project_end_date"
                            className="form-control" />
                          {formik.touched.project_end_date && formik.errors.project_end_date ? (
                            <div className="text-danger pt-2">{formik.errors.project_end_date}</div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card card-radius">
                  <div className="header card-header custum-bg-warning rounded">
                    <h2 className="text-white">Working group</h2>
                  </div>
                  <div className="body card-body-shadow">
                    <div className='row'>
                      <div className="col-lg-11 col-md-11 col-sm-11">
                        <div className="form-group">
                          <label htmlFor="partner" className="control-label">Current Partners<span className='text-danger'>*</span></label>
                          <input type="text" name="partner" 
                            id="partner" 
                            {...formik.getFieldProps('partner')} 
                            className="form-control"
                             placeholder='Please Enter Email' 
                            onChange={onChangeEmail}
                            defaultValue={currentPartnerEmail}
                          />
                          
                          <ul className='custom-search'>
                            {searchEmail ? searchEmail.map((email, index) => (<li onClick={() => AddToPartnerEmail(email.email)} key={index}>{email.email}</li>)) : null}
                          </ul>
                          {formik.touched.partner && formik.errors.partner ? (
                            <div className="text-danger pt-2">{formik.errors.partner}</div>
                          ) : null}
                          {formik.touched.partner_emails && formik.errors.partner_emails ? (
                            <div className="text-danger pt-2">{formik.errors.partner_emails}</div>
                          ) : null}
                        </div>

                        <ul className='custom-selected-value'>
                          {selectedPartners ? selectedPartners.map((email, index) => (<li className='chip' key={index}>{email.email} <span onClick={() => onRemoveEmail(email)}><i className='fa fa-close ml-2'></i></span></li>)) : null}
                        </ul>
                      </div>
                      <div className="col-lg-1 col-md-1 col-sm-1 mt-4 text-right">
                        <div className="form-group pt-1">
                          <button onClick={() => AddToPartnerEmail(currentPartnerEmail)} type='button' {...formik.getFieldProps('partner_email')} className='btn custom-btn-outline-info' disabled={currentPartnerEmail ? false : true}>Add</button>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-11 col-md-11 col-sm-11">
                        <div className="form-group">
                          <label htmlFor="title" className="control-label">Select members<span className='text-danger'>*</span></label>
                          <Multiselect
                            options={members}
                            selectedValues={selectedMembers}
                            onSelect={onSelectMembers}
                            onRemove={onRemoveMembers}
                            {...formik.getFieldProps('member_emails')}
                            displayValue="email"
                            showArrow={true}
                          />
                          {/* <input type="text" placeholder='Enter Invited Members By Comma Separated' name={'member_emails'} id="member_emails" className="form-control"  {...formik.getFieldProps('member_emails')} /> */}
                          {formik.touched.member_emails && formik.errors.member_emails ? (
                            <div className="text-danger pt-2">{formik.errors.member_emails}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-lg-1 col-md-1 col-sm-1 mt-4 text-right">
                        <div className="form-group pt-1">
                          <button onClick={() => handleAddMemberShow()} type='button' className='btn custom-btn-outline-info'>Add</button>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
            {/* reference */}
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card card-radius">
                  <div className="header card-header custum-bg-warning rounded">
                    <h2 className="text-white">References</h2>
                  </div>
                  <div className="body card-body-shadow">
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="form-group">
                          <label htmlFor="title" className="control-label">Select References</label>
                          <Multiselect
                            options={campaigns}
                            selectedValues={selectedReferences}
                            onSelect={onSelectReferences}
                            onRemove={onRemoveReferences}
                            {...formik.getFieldProps('campaigns')}
                            displayValue="name"
                            showArrow={true}
                          />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className='row px-2 pb-3 clearfix'>
              <div className='col-md-4 col-lg-6 col-sm-6'>
                <button type='button' onClick={formik.handleReset} className='btn btn-outline-danger'><i className='icon-close'></i> Discard</button>
              </div>
              <div className='col-md-4 col-lg-6 col-sm-6  text-right'>
                <button className='btn button' disabled={loading ? true : false} type='submit'>Create new brief</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <AddMemberModal
        open={showAddAdminModal}
        close={handleAddAdminClose}
        data={selectedRowData}
        onLoad={members}
        deleteData={null}
      />
    </>
  );
};
export default CreateProject;